module.exports = __webpack_public_path__ + "static/media/mastercardLogo.78c80603.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/patient-list/images/mastercardLogo.svg
// module id = 14026
// module chunks = 0